import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import NoFilter from '../../DataTable/datatable.nofilter';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import GradedReasonEditDialog from '../../Dialogs/Configuration/GradedReasonEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import { useHttpUtils } from '../../Utilities/useHttpUtils';
import CommonConfigPage from './CommonConfigPage';

function GradedReasonsTable({ showEditDialog, includeDeleted, refresh }) {
    const { fetchDataAuthenticated } = useHttpUtils();
    const [loaded, setLoaded] = useState(false);
    const [errored, setErrored] = useState(false);
    const [tableData, setTableData] = useState([]);

    useEffect(() => {
        const getGradedReasons = async function () {
            let url = `api/v1/gradedreason/?includeDeleted=${includeDeleted}`;

            await fetchDataAuthenticated(url)
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    }
                    throw new Error('Something went wrong.');
                })
                .then(data => {
                    setTableData(data);
                    setErrored(false);
                    setLoaded(true);
                })
                .catch(error => {
                    setErrored(true);
                    setLoaded(false);
                });
        };

        getGradedReasons();
    }, [fetchDataAuthenticated, includeDeleted, refresh]);

    const tableColumns = [
        {
            Header: 'Reason Code',
            accessor: 'reasonCode',
            filter: 'includesString',
            Cell: (props) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>);
            }
        },
        {
            Header: 'Description',
            accessor: 'description',
            filter: 'includesString'
        },
        {
            Header: 'Business Unit',
            accessor: 'businessUnitName',
            Filter: SelectFilter,
            filter: 'equals'
        },
        {
            Header: 'Translation',
            accessor: 'translation',
            Filter: NoFilter
        },
        {
            Header: 'Display Order',
            accessor: 'displayOrder',
            filter: 'equals'
        }
    ];

    const getRowProps = (row) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    let tableMarkup = (loaded
        ? <DataTable tableColumns={tableColumns} tableData={tableData} getRowProps={getRowProps} autoResetPage={false} />
        : errored
            ? <p>There was a problem.</p>
            : <CentredSpinner />
    );

    return tableMarkup;
}

function GradedReasonsConfiguration() {

    const { businessUnits } = useBusinessUnits(false);

    const getNewGradedReason = () => {
        return { gradedReasonId: null, reasonCode: "", description: "", businessUnitId: null, isDeleted: false };
    };

    return (
        <CommonConfigPage
            title="Graded Reasons"
            Table={GradedReasonsTable}
            Dialog={GradedReasonEditDialog}
            getNewConfigObject={getNewGradedReason}
            businessUnits={businessUnits}
        />
    );
}

export default GradedReasonsConfiguration;